import React from 'react'

import { YStack } from 'tamagui'

import { Grid } from './Grid'
import { Screen } from './Screen'

export function SettingsLayout({
  sidebar,
  children,
}: {
  sidebar: React.ReactNode
  children: React.ReactNode
}) {
  return (
    <Screen>
      {/* Mobile: stacked layout */}
      <YStack gap='$4' $gtSm={{ display: 'none' }}>
        {sidebar}

        <YStack>{children}</YStack>
      </YStack>

      {/* Desktop: two-column Grid layout */}
      <Grid gap='$12' display='none' $gtSm={{ display: 'flex' }}>
        <Grid.Column
          flex={3}
          $gtMd={{ flex: 2 }}
        >
          <YStack
            style={{ position: 'sticky', top: 116 }}
            alignSelf='flex-start'
          >
            {sidebar}
          </YStack>
        </Grid.Column>

        <Grid.Column
          flex={9}
          $gtMd={{ flex: 10 }}
        >
          {children}
        </Grid.Column>
      </Grid>
    </Screen>
  )
}
